export const BASE_BACKGROUND_RESETER = {
    backgroundImage: 'none', // Reset background set by base style
    backgroundColor: 'initial',
};

export function getButtonSidesIndent(buttonBorderRadius) {
    return buttonBorderRadius < 10 ? 8 : 16;
}
